import { gql } from '@apollo/client';

export const GET_ETS_QUIZ_QUESTIONS = gql`
  query GetETSQuizQuestions {
    getETSQuizQuestions {
      _id
      prompt
      trait
      scale
    }
  }
`;